module.exports = __webpack_public_path__ + "img/logo-blanco-completo.d0247085.png";